import { render, staticRenderFns } from "./PriceOfBusiness.vue?vue&type=template&id=698251dc&"
import script from "./PriceOfBusiness.vue?vue&type=script&lang=ts&"
export * from "./PriceOfBusiness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports